export default "__VITE_ASSET__DfVIgY62__"